import { createAction, props } from '@ngrx/store';
import { NotificationMessage, ResponseBadRequest } from '@core/interfaces';

export const NOTIFICATION_SHOW = createAction('[Notification] Show', props<{ notification: NotificationMessage }>());
export const NOTIFICATION_SYNC_CHANGES = createAction('[Notification] Sync Changes');
export const NOTIFICATION_CLEAR = createAction('[Notification] Clear');
export const SERVICE_FAILURE = createAction('[Notification] Service Failure', props<{ error: ResponseBadRequest }>());